import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=77bdea9d&"
import script from "./loading-overlay.vue?vue&type=script&lang=js&"
export * from "./loading-overlay.vue?vue&type=script&lang=js&"
import style0 from "./loading-overlay.vue?vue&type=style&index=0&id=77bdea9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports